import { render, staticRenderFns } from "./FundNavPensions.vue?vue&type=template&id=9170837c"
import script from "./FundNavPensions.vue?vue&type=script&lang=js"
export * from "./FundNavPensions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports